import { SET_MAIN_LOADING, SET_CLIENT_DROPDONW_DATA } from "../types/index";
import * as api from "../api/index";
import { handleApiError } from "Helper";
import { getActiveFeeEarner } from "services/userService";

export const setMainLoading = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: SET_MAIN_LOADING, payLoad: payLoad });
  } catch (error) { }
};

export const getClientDropDownData = () => async (dispatch, getState) => {
  let bData, ac, fe, aVats;
  try {
    if (!getState().common.feeEarner?.length) {
      const data = await getActiveFeeEarner();

      fe = data.data;
    }

    if (!bData || !ac || !fe || !aVats) return;
    dispatch({
      type: SET_CLIENT_DROPDONW_DATA,
      payLoad: {
        acctiveCurrencies: ac,
        feeEarner: fe,
        activeVats: aVats,
      },
    });
  } catch (error) {
    handleApiError(error);
  }
};
